module.exports = __webpack_public_path__ + "img/logo.ef9c9a92.png";